export default __webpack_public_path__ + "static/media/Saira_SemiExpanded-Regular.07fb151b.ttf";